import {Component} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {DayLabel} from '../../shared/models/markets-config.model';

// One row in the flat, cross-market priority list - `ref` is opaque to this dialog (the
// caller's own EditableBlock reference), handed back verbatim in the (possibly reordered)
// sequence so the caller can resolve back to its live block objects without this dialog
// needing to know anything about the caller's internal model.
export interface PriorityOrderRow {
    marketName: string;
    service: string;
    days: DayLabel[] | null;
    dateFrom: string | null;
    dateTo: string | null;
    overlapCount: number;
    ref: any;
}

@Component({
    selector: 'app-priority-order-dialog',
    templateUrl: './priority-order-dialog.component.html',
    styleUrls: ['./priority-order-dialog.component.scss']
})
export class PriorityOrderDialogComponent {
    // Set by the caller right after dialogService.open(), before the dialog is shown - the
    // dialog reorders this array in place via drag/drop, never adds/removes/edits a row.
    rows: PriorityOrderRow[] = [];

    constructor(private dialogRef: DialogRef) {
    }

    public onDrop(previousIndex: number, currentIndex: number): void {
        moveItemInArray(this.rows, previousIndex, currentIndex);
    }

    public onCancel(): void {
        this.dialogRef.close({confirmed: false});
    }

    public onApply(): void {
        this.dialogRef.close({confirmed: true, rows: this.rows});
    }
}
